/**
 * member
 */
'use strict';
import AppMemberEntry from '@/_modules/app_member_entry';

document.addEventListener('DOMContentLoaded', () => {
  new AppMemberEntry();
}, false);

window.addEventListener('load', () => {
}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});